import React from 'react'
import { useConnect } from 'sb-redux-hook'

import femaleRemoveIcon from './images/female/removeIcon.svg'
import maleRemoveIcon from './images/male/removeIcon.svg'


const RemoveIcon = ({ className, id, onRemove }) => {
  const { isMale } = useConnect({
    isMale: (state) => state.models.me === 'male',
  })

  const removeIcon  = isMale ? maleRemoveIcon : femaleRemoveIcon
  const isVisible   = typeof onRemove === 'function'

  return isVisible && (
    <img
      className={className}
      src={removeIcon}
      alt=""
      onClick={() => onRemove(id)}
    />
  )
}


export default RemoveIcon
